'use strict';

wbApp.directive('wbGrid3', ['$window', '$translate', '$filter', '$timeout', 'messageBoxSvc', 'securitySvc', 'gridSortSvc',
    function ($window, $translate, $filter, $timeout, messageBoxSvc, securitySvc, gridSortSvc) {

        return {
            restrict: 'A',
            scope: {
                gridSettings: '=',
                gridDataSource: '=',
                onDelete: '&',
                onEdit: '&',
                onAdd: '&',
                onCopy: '&',
                onSelectionChanged: '&',
                onFilterApplied: '&',
                resource: '@',
                idPrefix: '@'
            },
            template:
                '<div id="{{idPrefixFixed}}" dx-data-grid="settings" class="pl-data-grid" dx-item-alias="item" >' +
                    '<div data-options="dxTemplate: { name: \'commandBtnCellTemplate\' }">' +
                        '<div ng-click="$parent.submenuShowing(item)" class="wb-command-toggle" >' +
                            '<i class="fa fa-cog fa-lg"></i>' +
                            '<i class="fa fa-caret-down"></i>' +
                        '</div>' +
                    '</div>' +
                    '<div data-options="dxTemplate: { name: \'commandBtnHeaderTemplate\' }">' +
                        '<div class="dx-grid-command-button" id="{{$parent.idPrefixFixed}}grid-new-item-button" dx-button="$parent.commandColHeaderBtn"></div>' +
                    '</div>' +
                    '<div data-options="dxTemplate:{ name:\'masterDetail\' }" class="internal-grid-container">' +
                        '<div dx-data-grid="{{$parent.detailSetting}}" class="internal-grid">' +
                            '<div data-options="dxTemplate: { name: \'detailCommandBtnCellTemplate\' }">' +
                                '<div ng-click="$parent.submenuShowing(item)" class="wb-command-toggle" >' +
                                    '<i class="fa fa-cog fa-lg ng-animate"></i>' +
                                    '<i class="fa fa-caret-down"></i>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +                        
                    '</div>' +
                '</div>',
            replace: true,
            compile: function (tElem, tAttrs) {
                return {
                    pre: function (scope, iElem, iAttrs) {

                        scope.idPrefixFixed = scope.idPrefix;

                        var clickTimer, lastRowCLickedId;

                        function onRowClick(e){ 
                            var rows = scope.gridInstance.getSelectedRowsData();

                            if (clickTimer && lastRowCLickedId === e.rowIndex) {
                                clearTimeout(clickTimer);
                                clickTimer = null;
                                lastRowCLickedId = e.rowIndex;

                                raiseOnEdit(e.data);

                            } else {
                                clickTimer = setTimeout(function () {
                                    lastRowCLickedId = null;
                                }, 250);
                            }

                            lastRowCLickedId = e.rowIndex;
                        }

                        var savedColumnVisibility = [];

                        var defaultOptions = {
                            width: '100%',
                            height: '100%',
                            cacheEnabled: false,
                            rowAlternationEnabled: true,
                            showRowLines: true,
                            focusStateEnabled: false,
                            hoverStateEnabled: true,
                            bindingOptions: {
                                dataSource: 'gridDataSource',
                                filterRow: 'gridSettings.filterRow',
                                searchPanel: 'gridSettings.searchPanel'
                            },
                            paging: {
                                pageSize: 30
                            },
                            pager: {
                                showInfo: true,
                                showPageSizeSelector: true,
                                showNavigationButtons: true,
                                visible: "true"
                            },
                            filterRow: {                                
                                showOperationChooser: true
                            },
                            groupPanel: {
                                visible: false
                            },
                            selection: {
                                mode: 'single'
                            },
                            editing: {
                                allowUpdating: false,
                                allowDeleting: false,
                                allowAdding: false
                            },
                            allowColumnResizing: true,
                            remoteOperations: false,
                            onSelectionChanged: function (selectedRowsInfo) {
                                scope.prepareToolButtons();

                                if (iAttrs.onSelectionChanged) {
                                    if (selectedRowsInfo.selectedRowsData.length > 0) {
                                        scope.onSelectionChanged({ model: selectedRowsInfo.selectedRowsData[0] });
                                    }
                                }
                            },
                            onRowClick: onRowClick,
                            customCommands: [],
                            masterDetail: {
                                enabled: false,
                                settings: {
                                    selection: {
                                        mode: 'single'
                                    },
                                }
                            },
                            columnChooser: {
                                enabled: false,
                                mode: 'select',
                                title: $translate.instant('TXT_COLUMN_CHOOSER')
                            },
                            stateStoring: {
                                enabled: false,
                                storageKey: scope.idPrefixFixed + '-grid-setting',
                                type: 'localStorage',
                                ignoreColumnOptionNames: []
                            }
                        };

                        if (!scope.gridSettings.filterRow) {
                            scope.gridSettings.filterRow = {};
                        }

                        scope.settings = angular.extend({}, defaultOptions, scope.gridSettings);

                        scope.settings.stateStoring.enabled = scope.gridSettings.shouldShowColumnChooser;

                       // scope.settings.columns = scope.gridSettings.columns;

                        for(let i = 0; i < scope.settings.columns.length; i++) {
                            let column = scope.settings.columns[i];
                            if (column.calculateSortValue != null && column.dataField != null) {
                                column.calculateFilterExpression = (filterValue, selectedFilterOperation, target) =>
                                    gridSortSvc.filterExpressionWithoutAccents(filterValue, selectedFilterOperation, target, column.dataField)
                            }
                        }

                        scope.detailSetting = !!scope.gridSettings.masterDetail
                            ? scope.gridSettings.masterDetail.settings
                            : {};
                        if (scope.detailSetting.bindingOptions) {
                            scope.detailSetting.bindingOptions.onSelectionChanged = '$parent.detailOnSelectionChanged';
                            scope.detailSetting.bindingOptions.onRowPrepared = '$parent.detailonRowPrepared';
                        }

                        scope.detailOnSelectionChanged = function (e) {
                            if (scope.detailSetting.onSelectionChanged) {
                                scope.detailSetting.onSelectionChanged(e);
                            }
                        }

                        scope.detailonRowPrepared = function (e) {
                            if (scope.detailSetting.onRowPrepared) {
                                scope.detailSetting.onRowPrepared(e);
                            }
                        }

                        if (scope.settings.masterDetail.settings.columns) {
                            scope.settings.masterDetail.settings.columns.unshift(
                            {
                                dataField: 'siteKeyGroupID',
                                cellTemplate: 'detailCommandBtnCellTemplate',
                                allowFiltering: false,
                                allowGrouping: false,
                                allowHiding: false,
                                allowReordering: false,
                                allowResizing: false,
                                allowSorting: false,
                                caption: '',
                                width: '38px'
                            });
                        }

                        scope.commandMenuDS = [];
                        scope.detailCommandMenuDS = [];

                        function raiseOnEdit(data) {
                            if (!scope.shouldDisableEdit(data)) {
                                scope.onEdit({ model: data });
                            }
                        }

                        function raiseOnCopy(data) {
                            scope.onCopy({ model: data });
                        }

                        scope.menuItemClicked = function (val) {
                            switch (val.itemData.id) {
                                case 'add':
                                    if (iAttrs.onAdd) {
                                        scope.onAdd();
                                    }
                                    break;
                                case 'edit':
                                    raiseOnEdit(val.itemData.data);
                                    break;
                                case 'copy':
                                    if (iAttrs.onAdd) {
                                        raiseOnCopy(val.itemData.data);
                                    }
                                    break;
                                case 'delete':
                                    if (iAttrs.onDelete) {
                                        scope.showDeleteMsg(val.itemData.data);
                                    }
                                    break;
                                default:
                                    if (val.itemData.callback) {
                                        val.itemData.callback(val.itemData.data);
                                    }
                                    break;
                            }
                        }

                        var contextMenu = new DevExpress.ui.dxContextMenu($("<div id='" + scope.idPrefixFixed + "-context-menu'>").appendTo("body"), {
                            target: $(),
                            dataSource: scope.commandMenuDS,
                            onItemClick: scope.menuItemClicked,
                            position: { offset: '25 20' },
                            alternativeInvocationMode: { enabled: true },
                            width: function (w) {
                                return w + 150 + 'px';
                            }
                        });

                        scope.shouldDisableAdd = function () {
                            var enabled = true;
                            enabled = enabled && !!iAttrs.onAdd;
                            enabled = enabled && securitySvc.isInRole((scope.resource || '') + '.Insert');
                            if (!!scope.gridSettings.shouldDisableAdd) {
                                enabled = enabled && !scope.gridSettings.shouldDisableAdd();
                            }

                            return !enabled;
                        }

                        scope.shouldDisableExportMenu = function () {
                            var disable = false;

                            if (!!scope.gridSettings.shouldDisableExportMenu) {
                                disable = disable || scope.gridSettings.shouldDisableExportMenu();
                            }

                            return disable;
                        }

                        scope.shouldShowAdd = function () {
                            var show = true;

                            if (!!scope.gridSettings.shouldShowAdd) {
                                show = show && scope.gridSettings.shouldShowAdd();
                            }

                            return show;
                        }

                        scope.shouldDisableEdit = function (row) {
                            var enabled = true;
                            enabled = enabled && !!iAttrs.onEdit;                            
                            if (!!scope.gridSettings.shouldDisableEdit) {
                                enabled = enabled && !scope.gridSettings.shouldDisableEdit(row);
                            } else {
                                enabled = enabled && securitySvc.isInRole((scope.resource || '') + '.Update');
                            }

                            return !enabled;
                        }

                        scope.shouldDisableCopy = function (row) {
                            var enabled = true;
                            enabled = enabled && !!iAttrs.onCopy;
                            if (!!scope.gridSettings.shouldDisableCopy) {
                                enabled = enabled && !scope.gridSettings.shouldDisableCopy(row);
                            } else {
                                enabled = enabled && securitySvc.isInRole((scope.resource || '') + '.Insert');
                            }

                            return !enabled;
                        }

                        scope.shouldShowEdit = function (row) {
                            var show = true;

                            if (!!scope.gridSettings.shouldShowEdit) {
                                show = show && scope.gridSettings.shouldShowEdit(row);
                            }

                            return show;
                        }

                        scope.shouldShowCopy = function (row) {
                            var show = true;
                            show = show && !!iAttrs.onCopy;
                            if (!!scope.gridSettings.shouldShowCopy) {
                                show = show && scope.gridSettings.shouldShowCopy(row);
                            }

                            return show;
                        }

                        scope.shouldDisableDelete = function (row) {
                            var enabled = true;
                            enabled = enabled && !!iAttrs.onDelete;
                            if (!!scope.gridSettings.shouldDisableDelete) {
                                enabled = enabled && !scope.gridSettings.shouldDisableDelete(row);
                            } else {
                                enabled = enabled && securitySvc.isInRole((scope.resource || '') + '.Delete');
                            }

                            return !enabled;
                        }

                        scope.shouldShowDelete = function (row) {
                            var show = true;

                            if (!!scope.gridSettings.shouldShowDelete) {
                                show = show && scope.gridSettings.shouldShowDelete(row);
                            }

                            return show;
                        }

                        scope.menuItemCanBeginGroup = function (menu, item) {
                            if (!menu || !item) {
                                return false;
                            }

                            var atLeastOneVisible = false;
                            for (var i = 0; i < menu.length; i++) {
                                if (menu[i] !== item) {
                                    atLeastOneVisible = atLeastOneVisible || menu[i].visible;
                                } else {
                                    break;
                                }
                            }

                            return atLeastOneVisible;
                        }

                        if (iAttrs.onAdd) {
                            scope.commandMenuDS.push({
                                text: $translate.instant('TXT_MENU_NEW'),
                                id: "add",
                                isDisabled: scope.shouldDisableAdd,
                                isVisible: scope.shouldShowAdd
                            });
                        }

                        if (iAttrs.onEdit) {
                            scope.commandMenuDS.push({
                                text: $translate.instant('TXT_MENU_EDIT'),
                                id: "edit",
                                isDisabled: function (val) {
                                    return scope.shouldDisableEdit(val);
                                },
                                isVisible: function (val) {
                                    return scope.shouldShowEdit(val);
                                }
                            });
                        }

                        if (iAttrs.onCopy) {
                            scope.commandMenuDS.push({
                                text: $translate.instant('TXT_COPY'),
                                id: "copy",
                                isDisabled: function (val) {
                                    scope.shouldDisableCopy(val);
                                },
                                isVisible: function (val) {
                                    scope.shouldShowCopy(val);
                                }
                            });
                        }

                        if (iAttrs.onDelete) {
                            scope.commandMenuDS.push({
                                text: $translate.instant('TXT_MENU_DELETE'),
                                id: "delete",
                                beginGroup: scope.commandMenuDS.length > 0,
                                isDisabled: scope.shouldDisableDelete,
                                isVisible: function (val) {
                                    return scope.shouldShowDelete(val);
                                },
                                isBeginGroup: function (menu, item) {
                                    return scope.menuItemCanBeginGroup(menu, item);
                                }
                            });
                        }

                       var beginGroup = true;

                        angular.forEach(scope.settings.customCommands, function (item) {
                            scope.commandMenuDS.push({
                                text: item.text,
                                id: "custom-" + (!!item.id ? item.id : item.text.toLowerCase()),
                                beginGroup: beginGroup || !!item.beginGroup,
                                callback: item.callback,
                                isDisabled: !!item.isDisabled ? item.isDisabled : function () { return false; },
                                isVisible: !!item.isVisible ? item.isVisible : function () { return true; },
                                isBeginGroup: beginGroup || !!item.beginGroup 
                                    ? function (menu, item) { return scope.menuItemCanBeginGroup(menu, item); }
                                    : function () { return false; }
                            });
                            beginGroup = false;
                        });

                        angular.forEach(scope.settings.masterDetail.settings.customCommands, function (item) {
                            scope.detailCommandMenuDS.push({
                                text: item.text,
                                id: "custom-detail-" + (!!item.id ? item.id : item.text.toLowerCase()),
                                callback: item.callback,
                                isDisabled: !!item.isDisabled ? item.isDisabled : function () { return false; },
                                isVisible: !!item.isVisible ? item.isVisible : function () { return true; }
                            });
                        });


                        scope.commandColHeaderBtn = {
                            bindingOptions: {
                                disabled: '$parent.shouldDisableAdd()'
                            },
                            icon: 'fa fa-lg fa-edit',
                            width: '20px',
                            height: '14px',
                            onClick: function () {
                                if (iAttrs.onAdd) {
                                    scope.onAdd();
                                }
                            }
                        }

                        scope.submenuShowing = function (data) {

                            var id = scope.idPrefixFixed + 'list-row-context-menu';
                            var ds = contextMenu.option('dataSource');
                            for (var i = 0; i < ds.length; i++) {
                                var menuItem = ds[i];
                                menuItem.beginGroup = !!menuItem.isBeginGroup ? menuItem.isBeginGroup(ds, menuItem) : menuItem.beginGroup;
                                menuItem.disabled = menuItem.isDisabled(data.data);
                                menuItem.visible = menuItem.isVisible(data.data);
                                menuItem.data = data.data;
                            }
                            contextMenu.option('dataSource', ds);
                            contextMenu.option('target', data.cellElement);
                            contextMenu.show();
                        }

                        scope.detailSubmenuShowing = function (data) {
                            // TODO
                            //var id = scope.idPrefixFixed + 'list-row-' + (data.$parent.dxTemplateModel.rowIndex + 1) + '-detail-command-button-' + (data.dxTemplateModel.rowIndex + 1);
                            //var instance = $('#' + id).dxDropDownMenu('instance');
                            //var ds = instance.option('dataSource');
                            //for (var i = 0; i < ds.length; i++) {
                            //    var menuItem = ds[i];
                            //    menuItem.disabled = menuItem.isDisabled(data.data);
                            //}
                            //instance.option('dataSource', ds);
                        }

                        scope.detailMenuItemClicked = function (val) {
                            if (val.itemData.callback) {
                                val.itemData.callback(val.component._options.parentData, val.itemData.data);
                            }
                        }

                        scope.showDeleteMsg = function (model) {
                            if (!!scope.gridSettings.disableDeleteConfirmation) {
                                scope.onDelete({ model: model });
                            } else {
                                messageBoxSvc.showMessageDlg({
                                    title: 'TXT_TITLE_CONFIRM_DELETE',
                                    message: 'TXT_TEXT_CONFIRM_DELETE',
                                    buttons: [{
                                        text: 'TXT_BTN_NO'
                                    }, {
                                        text: 'TXT_BTN_YES',
                                        callback: function () { scope.onDelete({ model: model }); }
                                    }]
                                });
                            }
                        }

                        if (scope.commandMenuDS.length || iAttrs.onAdd) {
                            scope.settings.columns.unshift(
                            {
                                dataField: 'siteKeyGroupID',
                                cellTemplate: 'commandBtnCellTemplate',
                                headerCellTemplate: !!iAttrs.onAdd ? 'commandBtnHeaderTemplate' : null,
                                allowFiltering: false,
                                allowGrouping: false,
                                allowHiding: false,
                                allowReordering: false,
                                allowResizing: false,
                                allowSorting: false,
                                showInColumnChooser: false,
                                caption: '',
                                width: '38px'
                            });
                        }

                        scope.autoSizeGrid = function (repaint) {
                            if (scope.gridInstance) {
                                if (repaint) {
                                    scope.gridInstance.repaint();
                                }

                                var significantParent = iElem.closest('div.dx-grid-resize-pivot');

                                var newHeight = significantParent.length > 0
                                    ? significantParent.outerHeight() - iElem.prevAll().outerHeight() - iElem.nextAll().outerHeight()
                                    : iElem.parent().outerHeight() - iElem.prevAll().outerHeight() - iElem.nextAll().outerHeight();
                                var currentHeight = scope.gridInstance.option('height');
                                if (newHeight !== currentHeight) {
                                    scope.gridInstance.option('height', newHeight);
                                }
                            }
                        }

                       // scope.contextExportMenu = null;

                        scope.removeToolButtons = function () {
                            var exportMenuElementId = scope.idPrefixFixed + "-context-export-menu";
                            var elm = $("#" + exportMenuElementId);
                            if (elm.length > 0) {
                                elm.remove();
                            }
                        }

                        scope.prepareToolButtons = function () {
                            if (!scope.gridInstance) {
                                return;
                            }
                            
                            var exportMenuElementId = scope.idPrefixFixed + "-context-export-menu";
                            if ($("#" + exportMenuElementId).length === 0) {
                                scope.contextExportMenu = new DevExpress.ui.dxContextMenu($("<div id='" + exportMenuElementId + "'>").appendTo("body"), {
                                    target: $(),
                                    items: [{
                                        id: 'exportSelected',
                                        text: Globalize.formatMessage('dxDataGrid-exportToExcel'),
                                        disabled: scope.shouldDisableExportMenu()
                                    }],
                                    onItemClick: function (val) {
                                        switch (val.itemData.id) {
                                            case 'exportSelected': {
                                                const workbook = new ExcelJS.Workbook();
                                                const worksheet = workbook.addWorksheet('Main sheet');

                                                let notVisibleColumns = [];
                                                scope.gridInstance.beginUpdate();
                                                scope.settings.columns.forEach(function (col) {
                                                    if (col.visible !== undefined && !col.visible) {
                                                        notVisibleColumns.push(col);
                                                        scope.gridInstance.columnOption(col.dataField, "visible", true);
                                                    }
                                                });

                                                DevExpress.excelExporter.exportDataGrid({
                                                    worksheet: worksheet,
                                                    component: scope.gridInstance,
                                                    autoFilterEnabled: true
                                                }).then(function() {
                                                    workbook.xlsx.writeBuffer().then(function(buffer) {
                                                        let fileName =  'data-' + $filter('date')(new Date(), 'yyyy-MM-dd_HH-mm-ss-sss') + '.xlsx';
                                                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
                                                    });
                                                }).then(function() {
                                                    notVisibleColumns.forEach(function (col) {
                                                        scope.gridInstance.columnOption(col.dataField, "visible", false);
                                                    });
                                                    scope.gridInstance.endUpdate();
                                                }, function(error) {
                                                    notVisibleColumns.forEach(function (col) {
                                                        scope.gridInstance.columnOption(col.dataField, "visible", false);
                                                    });
                                                    scope.gridInstance.endUpdate();                                                    
                                                });
                                                break;
                                            }
                                        }
                                    },
                                    position: { offset: '25 20' },
                                    alternativeInvocationMode: { enabled: true },
                                    width: function (w) {
                                        return w + 150 + 'px';
                                    }
                                });
                            }
                            
                            var pagerDiv = $(scope.gridInstance.element()).find('div.dx-page-sizes');
                            var filterRowSwithElementId = scope.idPrefixFixed + "-filter-row-switch";

                            if ($("#" + filterRowSwithElementId).length === 0) {
                                var filterRowSwitchDiv = $("<div id='" + filterRowSwithElementId + "' class='dx-grid-tool-button'>").prependTo(pagerDiv);
                                filterRowSwitchDiv.dxButton({
                                    icon: 'fa fa-search',
                                    onClick: function () {
                                        scope.gridInstance.option('filterRow.visible', !scope.gridInstance.option('filterRow.visible'));
                                    }
                                });
                            }

                            if (!!scope.gridSettings.shouldShowColumnChooser) {
                                //var columnChooserButtonElementId = scope.idPrefixFixed + "-column-chooser-button";
                                //if ($("#" + columnChooserButtonElementId).length === 0) {
                                //    var columnChooserDiv = $("<div id='" + columnChooserButtonElementId + "' class='dx-grid-tool-button'>").prependTo(pagerDiv);
                                //    columnChooserDiv.dxButton({
                                //        icon: 'fa fa-table',
                                //        onClick: function () {
                                //            scope.gridInstance.showColumnChooser();
                                //        }
                                //    });
                                //}

                                var stateResetButtonElementId = scope.idPrefixFixed + "-state-reset-button";
                                if ($("#" + stateResetButtonElementId).length === 0) {
                                    var stateResetDiv = $("<div id='" + stateResetButtonElementId + "' class='dx-grid-tool-button'>").prependTo(pagerDiv);
                                    stateResetDiv.dxDropDownButton({
                                        icon: 'fa fa-table',
                                        useSelectMode: false,
                                        splitButton: true,
                                        stylingMode: 'outlined',
                                        keyExpr: 'id',
                                        displayExpr: 'text',
                                        hint: $translate.instant('TXT_COLUMN_CHOOSER'),
                                        items: [
                                            { id: 0, text: $translate.instant('TXT_COLUMN_CHOOSER') },
                                            { id: 1, text: $translate.instant('TXT_RESET_GRID_STATE') }],
                                        dropDownOptions: {
                                            minWidth: 150
                                        },
                                        onItemClick: function(e) {
                                            if (e.itemData.id == 0) {
                                                scope.gridInstance.showColumnChooser();
                                            } else if (e.itemData.id == 1) {
                                                $timeout(function () {
                                                    scope.gridInstance.state({});
                                                    scope.gridInstance.refresh();
                                                    scope.gridInstance.repaint();
                                                });
                                            }
                                        },
                                        onButtonClick: function () {
                                            scope.gridInstance.showColumnChooser();
                                        }
                                    });
                                }
                            }

                            var exportButtonElementId = scope.idPrefixFixed + "-export-button";
                            if ($("#" + exportButtonElementId).length === 0) {
                                var exportDiv = $("<div id='" + exportButtonElementId +"' class='dx-grid-tool-button'>").prependTo(pagerDiv);
                                exportDiv.dxButton({
                                    icon: 'fa fa-download',
                                    onClick: function () {
                                        scope.contextExportMenu.option('target', exportDiv);
                                        scope.contextExportMenu.show();
                                    }
                                });
                            }
                        }

                        scope.settings.onContentReady = function (e) {

                            scope.gridInstance = e.component;
                            scope.autoSizeGrid();

                            scope.gridSettings.gridInstance = e.component;

                            if (scope.gridSettings.onContentReady) {                                
                                scope.gridSettings.onContentReady(e);
                            }

                            if (iAttrs.onFilterApplied) {
                                var filterExpr =  scope.gridInstance.getCombinedFilter();
                                if (filterExpr) {
                                    var gridData = new DevExpress.data.DataSource({
                                        store: scope.gridDataSource,
                                        paginate: false
                                    });

                                    gridData.filter(filterExpr);
                                    gridData.load().done(function (result) {
                                        scope.onFilterApplied()(result);
                                    });
                                } else {
                                    scope.onFilterApplied()(scope.gridDataSource);
                                }
                            }

                            scope.prepareToolButtons();
                        }

                        var origOnCellPrepared = scope.settings.onCellPrepared;

                        scope.settings.onCellPrepared = function (e) {
                            if (e.rowType === 'filter') {
                                if (e.column['index'] === 0 &&
                                   (scope.commandMenuDS.length || iAttrs.onAdd)) {
                                    angular.element('<div class="dx-grid-command-button"/>')
                                        .dxButton({
                                            icon: 'clear',
                                            width: '17px',
                                            height: '14px',
                                            onClick: function () {
                                                if (scope.gridInstance) {
                                                    var columns = scope.gridInstance.option("columns");
                                                    for (var i = 0; i < columns.length; i++) {
                                                        scope.gridInstance.columnOption(i, "filterValue", undefined);
                                                    }
                                                }
                                            }
                                        })
                                        .appendTo(e.cellElement);
                                }
                            }

                            if (!!origOnCellPrepared) {
                                origOnCellPrepared(e);
                            }
                        }

                        scope.settings.onDisposing = function (e) {

                            scope.removeToolButtons();
                            e.component.off('contentReady');
                            scope.settings.onContentReady = null;

                            if (scope.onSplitterPaneResized) {
                                scope.onSplitterPaneResized();
                            }

                            if (scope.onActiveTabChanged) {
                                scope.onActiveTabChanged();
                            }
                        }
                    },
                    post: function (scope, iElem, iAttrs) {
                        scope.onSplitterPaneResized = scope.$on('splitter-pane-resized', function () {
                            if (scope.autoSizeGrid) {
                                scope.autoSizeGrid();
                            }
                        });

                        scope.onActiveTabChanged = scope.$on('activeTabChanged', function (event, data) {

                            if (data && data.activeTab !== undefined) {
                                var parentTab = iElem.closest('.dummy-tab-pane-class');
                                if (parentTab.length === 1) {
                                    var ownTabIndex = parentTab.attr('tab-index');
                                    if (ownTabIndex == data.activeTab) {
                                        $timeout(function () {
                                            scope.autoSizeGrid(true);
                                        }, 10);
                                        $timeout(function () {
                                            scope.autoSizeGrid(true);
                                        }, 200);
                                    }
                                }
                            }
                        });

                        angular.element($window).bind('resize', function () {
                            if (scope.autoSizeGrid) {
                                scope.autoSizeGrid();
                            }
                        });
                    }
                }
            }
        }
    }]);